import type { FC } from 'react';
import type { LinksFunction } from '@remix-run/node';

import clsx from 'clsx';

import type { HackerViewButtonProps } from './hacker-view-button.types';

import styles from './hacker-view-button.css?url';

export const links: LinksFunction = () => {
  return [{ rel: 'stylesheet', href: styles }];
};

export const HackerViewButton: FC<HackerViewButtonProps> = ({
  children,
  className,
  disabled = false,
  display,
  intent = 'primary',
  isFullWidth = false,
  onClick,
  type = 'button',
  ...rest
}) => {
  const classes = clsx('hacker-view-button', className, {
    'hacker-view-button--primary': intent === 'primary',
    'hacker-view-button--secondary': intent === 'secondary',
    'hacker-view-button--text': intent === 'text',
    'hacker-view-button--display-inline': display === 'inline',
    'hacker-view-button--full-width': isFullWidth,
  });

  return (
    <button
      className={classes}
      {...rest}
      type={type}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
